import React from "react";
import ActionIcon from "./action-icon";
import { GripVertical } from "lucide-react";
import BusinessContext from "../../contexts/business-context";
import { useContext } from "react";
import DynamicIcon from "./dynamic-icon";
import { useTranslations } from "next-intl";
import { setCachedBusiness } from "../../lib/utils";

const BusinessMenuItem = ({ businessName, teamCount, id }) => {
  const { activeBusiness } = useContext(BusinessContext);
  const businessId = activeBusiness.uuid;
  const t = useTranslations('nav');

  const handleClick = (e) => {
    e.preventDefault();
    setCachedBusiness(id);
    window.location.replace(`/${id}/inbox`);
  };

  const isActive = id === businessId;

  return (
    <div onClick={handleClick} className={`grid w-full items-center hover:custom-bg-grey-50 cursor-pointer content-center justify-between grid-flow-col gap-[16px] ${isActive ? 'custom-bg-grey-50' : ''} group p-1.5 px-3 rounded-lg`}>
      <div className="grid justify-start grid-flow-col gap-3 items-center">
        <div className="grid grid-flow-col gap-3 items-center">
          <div
            className={`w-[28px] h-[28px] grid justify-center items-center leading-[28px] text-center custom-text-grey-100 group-hover:custom-bg-white-50 ${isActive ? 'custom-bg-white-50' : ''} uppercase rounded-md font-bold text-[18px]`}
          >
            {businessName[0]}
          </div>
          <div className="grid grid-flow-col items-center">
            <div className="grid">
              <span
                className="poppins-bold text-[14px] custom-text-grey-800 text-start leading-[15px] truncate"
              >
                {businessName}
              </span>
              <span className="poppins-light custom-text-grey-800 text-start text-[12px]">
                {t('freePlan')}
              </span>
            </div>
          </div>
        </div>
      </div>
      {isActive && <DynamicIcon name='check' size={18} color='custom-text-grey-800' />}
    </div>
  );
};

export default BusinessMenuItem;
